import { getCurrentDate } from './apiSport';
const mqtt = require('mqtt');
const pako = require('pako');

const _qos = 0;
const _time = getCurrentDate();

// MQTT Configuration
const MQTT_BROKER_URL = `${process.env.REACT_APP_MQTT_PROTOCOL}://${process.env.REACT_APP_MQTT_HOST}${process.env.REACT_APP_MQTT_PATH}`;
const clientId = `chatboxn_${Math.random().toString(16).slice(3)}`;
const MQTT_OPTIONS = {
  clientId,
  clean: false,
  connectTimeout: 4000,
  reconnectPeriod: 1000,
};

let client = null;
let isSubscribed = false; // Biến đánh dấu trạng thái subscribe

// Decompress the message
const decompressMessage = compressedMessage => {
  try {
    const compressedData = new Uint8Array(compressedMessage);
    const decompressedData = pako.inflate(compressedData, { to: 'string' });
    return JSON.parse(decompressedData);
  } catch (error) {
    console.log(`${_time} ChatBox | Error decompressing message:`, error);
    return null;
  }
};

// Connect to MQTT Broker
export const connectMqtt = (onMessageCallback, topic) => {
  if (client && client.connected) {
    console.log(`${_time} ChatBox | Already connected ${topic}-${_qos}`);
    if (topic && !isSubscribed) {
      subscribeToTopic(topic, onMessageCallback);
    }
    return;
  }

  client = mqtt.connect(MQTT_BROKER_URL, MQTT_OPTIONS);

  client.on('connect', () => {
    console.log(`${_time} ChatBox | Connected ${topic}-${_qos}-${isSubscribed}`);
    if (topic && !isSubscribed) {
      subscribeToTopic(topic, onMessageCallback);
    }
  });

  client.on('reconnect', () => {
    console.log(`${_time} ChatBox | Reconnecting ${topic}-${_qos}-${isSubscribed}`);
    isSubscribed = false;  // Reset trạng thái subscribe khi reconnect
  });

  client.on('error', err => {
    console.log(`${_time} ChatBox | MQTT Error ${topic}-${_qos}`, err);
    client.end();
    client = null;
  });

  client.on('message', (topic, message) => {
    const parsedMessage = decompressMessage(message);
    if (parsedMessage) {
      if (onMessageCallback) {
        onMessageCallback(topic, parsedMessage);
      } else {
        console.log(`${_time} ChatBox | No onMessageCallback provided.`);
      }
    }
  });
};

// Subscribe to a Topic
export const subscribeToTopic = (topic, onMessageCallback) => {
  // Nếu client là null, thực hiện kết nối lại
  if (!client) {
    console.log(`${_time} ChatBox | MQTT client is not initialized yet.`);
    connectMqtt(onMessageCallback, topic);
    return;
  }

  if (client.connected) {
    client.subscribe(topic, { qos: _qos }, (err, granted) => {
      if (err) {
        console.log(`${_time} ChatBox | Subscription error for ${topic}-${_qos}:`, err);
      } else {
        console.log(`${_time} ChatBox | Subscribed ${topic}-${_qos}`);
        isSubscribed = true; // Đánh dấu là đã subscribe thành công
      }
    });
  } else {
    console.log(`${_time} Client not yet connected, will subscribe on 'connect' event`);
  }
};

// Disconnect MQTT
export const disconnectMqtt = () => {
  if (client) {
    client.end(() => {
      console.log(`${_time} ChatBox |  Disconnected from MQTT Broker`);
      client = null;
      isSubscribed = false; // Reset trạng thái subscribe khi ngắt kết nối
    });
  }
};

// Utility to show last characters of a string
export const showLastNChars = (inputString, length = 5, dots = '...') => {
  return `${dots}${inputString.slice(-length)}`;
};
